/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendD1OverviewResponseDto } from '../models/backend-d-1-overview-response-dto';
import { BackendD2TimeseriesResponseDto } from '../models/backend-d-2-timeseries-response-dto';
import { BackendD4TimeseriesResponseDto } from '../models/backend-d-4-timeseries-response-dto';
import { BackendD8ByProductResponseDto } from '../models/backend-d-8-by-product-response-dto';
import { BackendD8GridResponseDto } from '../models/backend-d-8-grid-response-dto';
import { BackendD8TotalResponseDto } from '../models/backend-d-8-total-response-dto';
import { BackendD9KpiResponseDto } from '../models/backend-d-9-kpi-response-dto';
import { BackendD9TableResponseDto } from '../models/backend-d-9-table-response-dto';
import { BackendD9TimeseriesResponseDto } from '../models/backend-d-9-timeseries-response-dto';
import { getByProductDashboardsD8ByProductGet } from '../fn/dashboards/get-by-product-dashboards-d-8-by-product-get';
import { GetByProductDashboardsD8ByProductGet$Params } from '../fn/dashboards/get-by-product-dashboards-d-8-by-product-get';
import { getGridDashboardsD8GridGet } from '../fn/dashboards/get-grid-dashboards-d-8-grid-get';
import { GetGridDashboardsD8GridGet$Params } from '../fn/dashboards/get-grid-dashboards-d-8-grid-get';
import { getKpiDashboardsD9KpiGet } from '../fn/dashboards/get-kpi-dashboards-d-9-kpi-get';
import { GetKpiDashboardsD9KpiGet$Params } from '../fn/dashboards/get-kpi-dashboards-d-9-kpi-get';
import { getOverviewEndpointDashboardsD1OverviewGet } from '../fn/dashboards/get-overview-endpoint-dashboards-d-1-overview-get';
import { GetOverviewEndpointDashboardsD1OverviewGet$Params } from '../fn/dashboards/get-overview-endpoint-dashboards-d-1-overview-get';
import { getPortfolioEndpointDashboardsD1PortfolioGet } from '../fn/dashboards/get-portfolio-endpoint-dashboards-d-1-portfolio-get';
import { GetPortfolioEndpointDashboardsD1PortfolioGet$Params } from '../fn/dashboards/get-portfolio-endpoint-dashboards-d-1-portfolio-get';
import { getTableDashboardsD9TableGet } from '../fn/dashboards/get-table-dashboards-d-9-table-get';
import { GetTableDashboardsD9TableGet$Params } from '../fn/dashboards/get-table-dashboards-d-9-table-get';
import { getTimeseriesDashboardsD9TimeseriesGet } from '../fn/dashboards/get-timeseries-dashboards-d-9-timeseries-get';
import { GetTimeseriesDashboardsD9TimeseriesGet$Params } from '../fn/dashboards/get-timeseries-dashboards-d-9-timeseries-get';
import { getTimeseriesEndpointDashboardsD2TimeseriesGet } from '../fn/dashboards/get-timeseries-endpoint-dashboards-d-2-timeseries-get';
import { GetTimeseriesEndpointDashboardsD2TimeseriesGet$Params } from '../fn/dashboards/get-timeseries-endpoint-dashboards-d-2-timeseries-get';
import { getTimeseriesEndpointDashboardsD4TimeseriesGet } from '../fn/dashboards/get-timeseries-endpoint-dashboards-d-4-timeseries-get';
import { GetTimeseriesEndpointDashboardsD4TimeseriesGet$Params } from '../fn/dashboards/get-timeseries-endpoint-dashboards-d-4-timeseries-get';
import { getTotalDashboardsD8TotalGet } from '../fn/dashboards/get-total-dashboards-d-8-total-get';
import { GetTotalDashboardsD8TotalGet$Params } from '../fn/dashboards/get-total-dashboards-d-8-total-get';
import { BackendPageD1PortfolioItemDto } from '../models/backend-page-d-1-portfolio-item-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiDashboardsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getKpiDashboardsD9KpiGet()` */
  static readonly GetKpiDashboardsD9KpiGetPath = '/dashboards/d9/kpi';

  /**
   * D9 KPI: revenue, gross_profit (главное), gross_margin, ebitda, net_profit за период.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getKpiDashboardsD9KpiGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKpiDashboardsD9KpiGet$Response(
    params: GetKpiDashboardsD9KpiGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD9KpiResponseDto>> {
    return getKpiDashboardsD9KpiGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D9 KPI: revenue, gross_profit (главное), gross_margin, ebitda, net_profit за период.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getKpiDashboardsD9KpiGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKpiDashboardsD9KpiGet(
    params: GetKpiDashboardsD9KpiGet$Params,
    context?: HttpContext,
  ): Observable<BackendD9KpiResponseDto> {
    return this.getKpiDashboardsD9KpiGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD9KpiResponseDto>): BackendD9KpiResponseDto => r.body),
    );
  }

  /** Path part for operation `getTimeseriesDashboardsD9TimeseriesGet()` */
  static readonly GetTimeseriesDashboardsD9TimeseriesGetPath = '/dashboards/d9/timeseries';

  /**
   * D9 временной ряд по выбранной гранулярности.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTimeseriesDashboardsD9TimeseriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesDashboardsD9TimeseriesGet$Response(
    params: GetTimeseriesDashboardsD9TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD9TimeseriesResponseDto>> {
    return getTimeseriesDashboardsD9TimeseriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D9 временной ряд по выбранной гранулярности.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTimeseriesDashboardsD9TimeseriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesDashboardsD9TimeseriesGet(
    params: GetTimeseriesDashboardsD9TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BackendD9TimeseriesResponseDto> {
    return this.getTimeseriesDashboardsD9TimeseriesGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD9TimeseriesResponseDto>): BackendD9TimeseriesResponseDto => r.body),
    );
  }

  /** Path part for operation `getTableDashboardsD9TableGet()` */
  static readonly GetTableDashboardsD9TableGetPath = '/dashboards/d9/table';

  /**
   * D9 таблица P&L по выбранной гранулярности.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTableDashboardsD9TableGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTableDashboardsD9TableGet$Response(
    params: GetTableDashboardsD9TableGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD9TableResponseDto>> {
    return getTableDashboardsD9TableGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D9 таблица P&L по выбранной гранулярности.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTableDashboardsD9TableGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTableDashboardsD9TableGet(
    params: GetTableDashboardsD9TableGet$Params,
    context?: HttpContext,
  ): Observable<BackendD9TableResponseDto> {
    return this.getTableDashboardsD9TableGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD9TableResponseDto>): BackendD9TableResponseDto => r.body),
    );
  }

  /** Path part for operation `getOverviewEndpointDashboardsD1OverviewGet()` */
  static readonly GetOverviewEndpointDashboardsD1OverviewGetPath = '/dashboards/d1/overview';

  /**
   * D1: KPI активного сценария проекта (NPV, IRR, PI, MIRR, окупаемость, среднее за год, финансирование).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOverviewEndpointDashboardsD1OverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewEndpointDashboardsD1OverviewGet$Response(
    params: GetOverviewEndpointDashboardsD1OverviewGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD1OverviewResponseDto>> {
    return getOverviewEndpointDashboardsD1OverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D1: KPI активного сценария проекта (NPV, IRR, PI, MIRR, окупаемость, среднее за год, финансирование).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOverviewEndpointDashboardsD1OverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewEndpointDashboardsD1OverviewGet(
    params: GetOverviewEndpointDashboardsD1OverviewGet$Params,
    context?: HttpContext,
  ): Observable<BackendD1OverviewResponseDto> {
    return this.getOverviewEndpointDashboardsD1OverviewGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD1OverviewResponseDto>): BackendD1OverviewResponseDto => r.body),
    );
  }

  /** Path part for operation `getPortfolioEndpointDashboardsD1PortfolioGet()` */
  static readonly GetPortfolioEndpointDashboardsD1PortfolioGetPath = '/dashboards/d1/portfolio';

  /**
   * D1: таблица портфеля проектов (только для администраторов).
   *
   * Список всех активных проектов с их KPI. Доступен только пользователям с `is_admin=true`. Видимости «свои проекты» здесь нет — админ видит всё.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPortfolioEndpointDashboardsD1PortfolioGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortfolioEndpointDashboardsD1PortfolioGet$Response(
    params?: GetPortfolioEndpointDashboardsD1PortfolioGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPageD1PortfolioItemDto>> {
    return getPortfolioEndpointDashboardsD1PortfolioGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D1: таблица портфеля проектов (только для администраторов).
   *
   * Список всех активных проектов с их KPI. Доступен только пользователям с `is_admin=true`. Видимости «свои проекты» здесь нет — админ видит всё.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPortfolioEndpointDashboardsD1PortfolioGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortfolioEndpointDashboardsD1PortfolioGet(
    params?: GetPortfolioEndpointDashboardsD1PortfolioGet$Params,
    context?: HttpContext,
  ): Observable<BackendPageD1PortfolioItemDto> {
    return this.getPortfolioEndpointDashboardsD1PortfolioGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPageD1PortfolioItemDto>): BackendPageD1PortfolioItemDto => r.body),
    );
  }

  /** Path part for operation `getTimeseriesEndpointDashboardsD2TimeseriesGet()` */
  static readonly GetTimeseriesEndpointDashboardsD2TimeseriesGetPath = '/dashboards/d2/timeseries';

  /**
   * D2 ФОТ: помесячная динамика плановых зарплат, разбитая по типам персонала.
   *
   * Каждый item — один месяц, внутри items[].groups всегда три записи (Производственный/Торгово-коммерческий/Управленческий), нули там, где данных нет. Учитываются ВСЕ строки opex_salary включая is_blocked. Индексация и налоги не применяются — см. docs/dashboards/d2.md.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTimeseriesEndpointDashboardsD2TimeseriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesEndpointDashboardsD2TimeseriesGet$Response(
    params: GetTimeseriesEndpointDashboardsD2TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD2TimeseriesResponseDto>> {
    return getTimeseriesEndpointDashboardsD2TimeseriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D2 ФОТ: помесячная динамика плановых зарплат, разбитая по типам персонала.
   *
   * Каждый item — один месяц, внутри items[].groups всегда три записи (Производственный/Торгово-коммерческий/Управленческий), нули там, где данных нет. Учитываются ВСЕ строки opex_salary включая is_blocked. Индексация и налоги не применяются — см. docs/dashboards/d2.md.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTimeseriesEndpointDashboardsD2TimeseriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesEndpointDashboardsD2TimeseriesGet(
    params: GetTimeseriesEndpointDashboardsD2TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BackendD2TimeseriesResponseDto> {
    return this.getTimeseriesEndpointDashboardsD2TimeseriesGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD2TimeseriesResponseDto>): BackendD2TimeseriesResponseDto => r.body),
    );
  }

  /** Path part for operation `getTimeseriesEndpointDashboardsD4TimeseriesGet()` */
  static readonly GetTimeseriesEndpointDashboardsD4TimeseriesGetPath = '/dashboards/d4/timeseries';

  /**
   * D4: 14 финансовых коэффициентов помесячно/погодно.
   *
   * Возвращает ВСЕ 14 коэффициентов одним пакетом (как Django UI). Фронт сам решает, что отрисовать как gauge, что линиями, что таблицей. Для granularity=year берётся последнее значение в каждом году (LAST), идентично Django `data_formatter(period='year', summarize=False)`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTimeseriesEndpointDashboardsD4TimeseriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesEndpointDashboardsD4TimeseriesGet$Response(
    params: GetTimeseriesEndpointDashboardsD4TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD4TimeseriesResponseDto>> {
    return getTimeseriesEndpointDashboardsD4TimeseriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D4: 14 финансовых коэффициентов помесячно/погодно.
   *
   * Возвращает ВСЕ 14 коэффициентов одним пакетом (как Django UI). Фронт сам решает, что отрисовать как gauge, что линиями, что таблицей. Для granularity=year берётся последнее значение в каждом году (LAST), идентично Django `data_formatter(period='year', summarize=False)`.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTimeseriesEndpointDashboardsD4TimeseriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesEndpointDashboardsD4TimeseriesGet(
    params: GetTimeseriesEndpointDashboardsD4TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BackendD4TimeseriesResponseDto> {
    return this.getTimeseriesEndpointDashboardsD4TimeseriesGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD4TimeseriesResponseDto>): BackendD4TimeseriesResponseDto => r.body),
    );
  }

  /** Path part for operation `getByProductDashboardsD8ByProductGet()` */
  static readonly GetByProductDashboardsD8ByProductGetPath = '/dashboards/d8/by-product';

  /**
   * D8: динамика продаж по продуктам (для стэкбара).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByProductDashboardsD8ByProductGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByProductDashboardsD8ByProductGet$Response(
    params: GetByProductDashboardsD8ByProductGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD8ByProductResponseDto>> {
    return getByProductDashboardsD8ByProductGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D8: динамика продаж по продуктам (для стэкбара).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByProductDashboardsD8ByProductGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByProductDashboardsD8ByProductGet(
    params: GetByProductDashboardsD8ByProductGet$Params,
    context?: HttpContext,
  ): Observable<BackendD8ByProductResponseDto> {
    return this.getByProductDashboardsD8ByProductGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD8ByProductResponseDto>): BackendD8ByProductResponseDto => r.body),
    );
  }

  /** Path part for operation `getTotalDashboardsD8TotalGet()` */
  static readonly GetTotalDashboardsD8TotalGetPath = '/dashboards/d8/total';

  /**
   * D8: суммарный план продаж (для общей линии и итоговой панели).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTotalDashboardsD8TotalGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalDashboardsD8TotalGet$Response(
    params: GetTotalDashboardsD8TotalGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD8TotalResponseDto>> {
    return getTotalDashboardsD8TotalGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D8: суммарный план продаж (для общей линии и итоговой панели).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTotalDashboardsD8TotalGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalDashboardsD8TotalGet(
    params: GetTotalDashboardsD8TotalGet$Params,
    context?: HttpContext,
  ): Observable<BackendD8TotalResponseDto> {
    return this.getTotalDashboardsD8TotalGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD8TotalResponseDto>): BackendD8TotalResponseDto => r.body),
    );
  }

  /** Path part for operation `getGridDashboardsD8GridGet()` */
  static readonly GetGridDashboardsD8GridGetPath = '/dashboards/d8/grid';

  /**
   * D8: полная таблица «продукт × месяц» + итоговая строка.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGridDashboardsD8GridGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGridDashboardsD8GridGet$Response(
    params: GetGridDashboardsD8GridGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD8GridResponseDto>> {
    return getGridDashboardsD8GridGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D8: полная таблица «продукт × месяц» + итоговая строка.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGridDashboardsD8GridGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGridDashboardsD8GridGet(
    params: GetGridDashboardsD8GridGet$Params,
    context?: HttpContext,
  ): Observable<BackendD8GridResponseDto> {
    return this.getGridDashboardsD8GridGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD8GridResponseDto>): BackendD8GridResponseDto => r.body),
    );
  }
}
